module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manage-script-markers-root"
  }, [_c('md-dialog', {
    ref: "manageDialog",
    staticClass: "manage-script-markers-dialog"
  }, [_c('md-dialog-title', [_vm._v("Manage structure")]), _vm._v(" "), _c('md-dialog-content', [(!_vm.sortedMarkers.length) ? _c('p', {
    staticClass: "marker-empty-hint"
  }, [_vm._v("No act, scene, or song structure marks yet.")]) : _c('md-list', {
    staticClass: "marker-list"
  }, _vm._l((_vm.sortedMarkers), function(marker) {
    return _c('md-list-item', {
      key: marker.markerId || marker.id
    }, [_c('div', {
      staticClass: "marker-row"
    }, [_c('span', {
      staticClass: "marker-type",
      class: ("marker-type-" + (marker.type))
    }, [_vm._v(_vm._s(_vm.typeLabel(marker.type)))]), _vm._v(" "), _c('span', {
      staticClass: "marker-label"
    }, [_vm._v(_vm._s(marker.label))]), _vm._v(" "), _c('span', {
      staticClass: "marker-page"
    }, [_vm._v(_vm._s(_vm.pageLabel(marker.pageIndex)))]), _vm._v(" "), _c('span', {
      staticClass: "marker-actions"
    }, [_c('md-button', {
      staticClass: "md-icon-button md-dense",
      on: {
        "click": function($event) {
          return _vm.editMarker(marker)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Edit")])], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-dense",
      on: {
        "click": function($event) {
          return _vm.confirmDelete(marker)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete")])], 1)], 1)])])
  }), 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("Add structure mark")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('script-marker-dialog', {
    ref: "markerDialog",
    attrs: {
      "currentPage": _vm.currentPage,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight,
      "totalPages": _vm.totalPages
    },
    on: {
      "saved": _vm.onMarkerSaved
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deleteDialog",
    attrs: {
      "md-title": "Delete marker",
      "md-content-html": _vm.deleteConfirmHtml,
      "md-ok-text": "Delete",
      "md-cancel-text": "Cancel"
    },
    on: {
      "close": _vm.onDeleteConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a808f82a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/markers/manage-markers-dialog.vue
// module id = 1280
// module chunks = 21